import { SEARCH_SEARCH_RIGHTHOLDERS_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  rightholderList: null,
  rightholderCount: null,
  query: null,
  pageNumber: 1,
  lastPageNumber: 1,
  isLoading: true,
};

export default function searchRightholders(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_RIGHTHOLDERS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
